<template>
    <div class="content page-2">
        <!-- Loop through as many times as there are travelers -->
        <CustomerForm @updated="updatedCustomer" :customer="$store.state.customer" :show-errors="showErrors"/>

        <TravellerForm v-for="guestNumber in numberOfGuests"
                       :number="guestNumber"
                       :key="guestNumber" :show-errors="showErrors"
                       :traveller="$store.state.travellers[guestNumber - 1]"
                       @updated="updatedTraveller"/>


        <portal to="navButtons">
            <button class="checkout-button button button-fat fat-outline float-left"
                    @click="$router.push({name: 'page1'})">
                Tilbake
            </button>
            <button class="checkout-button button button-fat float-right" @click="goToNextStep" :class="{disabled: !canGoToNextStep}">
                Fortsett
            </button>
        </portal>


        <portal to="overviewButtons">
            <button class="overview-button button button-fat w-100" @click="goToNextStep" :class="{disabled: !canGoToNextStep}">
                Fortsett til neste trinn
            </button>
        </portal>


    </div>
</template>
<script>
    import CustomerForm from "../CustomerForm";
    import TravellerForm from "../TravellerForm";
    import {mapGetters} from 'vuex'

    export default {
        name: "Page2",
        components: {
            CustomerForm,
            TravellerForm
        },
        data() {
            return {
                showErrors: false,
            }
        },
        computed: {
            ...mapGetters([
                'numberOfTravellers'
            ]),
            numberOfGuests() {
                return this.numberOfTravellers - 1;
            },
            canGoToNextStep: {
                cache: false,
                get() {
                    return this.$store.getters.hasFilledAllTravelerInformation;
                },
            },
        },
        methods: {
            goToNextStep() {
                if (!this.canGoToNextStep) {
                    this.showErrors = true;
                    return false;
                }

                if (this.$store.getters.canAutomaticallyAssignTravelersToRooms) {
                    this.$store.dispatch("automaticallyAssignTravelers");
                    this.$router.push({name: 'page3'});
                } else {
                    // Reset room assignments if the room selection or traveller list has changed (aka, is no longer valid)
                    if (this.$store.state.roomsOrTravellersHaveChanged) {
                        this.$store.commit("updateRoomAssignments", []);
                    }

                    this.$router.push({name: 'page21'});
                }
            },
            updatedTraveller(data, number) {
                this.$store.commit('updateTraveller', {traveller: data, number: number})
            },
            updatedCustomer(data) {
                this.$store.commit('updateCustomer', data)
            }
        }
    };
</script>
